import { SubscriptionLogV2 } from "../../../../../types"

interface Props {
  info: SubscriptionLogV2
}

const ViewDashboardCell: React.FC<Props> = ({ info }) => {
  return (
    <td className="view-dashboard-cell relative whitespace-nowrap py-4 px-0 text-right text-sm cursor-pointer sm:pr-6 pl-3 md:pr-4 hidden md:table-cell">
      {info.dashboard_link ? (
        <a
          className="pb-1 border-b border-dotted border-neutral-400  invisible group-hover:visible"
          href={info.dashboard_link}
          target="_blank"
          rel="noreferrer"
        >
          View dashboard
        </a>
      ) : null}
    </td>
  )
}
export default ViewDashboardCell
